import { ICloudStorageProvider } from "./i-cloud-storage-provider";
import { HttpService } from "../../infrastructure/http/http";
import { UserService } from "../user-service";
import { Logger } from "../../infrastructure/logger";
import { Auth } from "../../infrastructure/auth";
import { HttpClient } from "@angular/common/http";

export abstract class ICloudStorageProviderFactory {
  abstract createInstance(
    httpService: HttpService,
    userService: UserService,
    logger: Logger,
    auth: Auth,
    httpClient: HttpClient,
  ): ICloudStorageProvider;
  abstract getCurrent(): ICloudStorageProvider;
}
